import React from "react";
import style from "./UnableToAssessWound.module.scss";
import { useUnableToAssessWound } from "./hooks/useUnableToAssessWound";
import { Modal } from "../../../secondary";
import { getPatientRefusalReason } from "../../../../utils";

export const UN_ASSESS_WOUND_TYPE = [
  {
    key: "Patient Refusal",
    value: "Patient Refusal",
    desc: "Patient refused the wound evaluation for that week.",
    icon: <i className="fa fa-user" aria-hidden="true" />,
  },
  {
    key: "Bed Hold",
    value: "Bed Hold",
    desc: "Patient is on bed hold and unavailable for wound assessment.",
    icon: <i className="fa fa-bed" aria-hidden="true" />,
  },
];

const UnableToAssessWound = ({ onClose }) => {
  const { activeChip, notes, isSuccess, isLoading, isDisabled, selectedReasons, handleNoteChange, handleSelect, handleConfirm } = useUnableToAssessWound();

  return (
    <Modal modalOpen={true} modalSize={style.custom_modal_size}>
      <div className={style.container}>
        <div className={style.header}>
          <h2 className={style.title}>{isSuccess ? "Unable to assess wound" : "Select why you are unable to assess wound"}</h2>
          <button className={style.close_btn} onClick={onClose} aria-label="Close modal">
            &times;
          </button>
        </div>

        {isSuccess ? (
          <div className={style.success_state}>
            <div className={style.success_icon}>
              <i className="fa fa-check-circle" aria-hidden="true" />
            </div>
            {/* <p className={style.success_text}>{getPatientRefusalReason(activeChip)} Documented</p> */}
            <p className={style.success_text}>{activeChip} Documented</p>
          </div>
        ) : (
          <div>
            <div className={style.grid}>
              {UN_ASSESS_WOUND_TYPE?.map((item, index) => (
                <button
                  key={item.key}
                  className={`${style.card} ${activeChip === item.key ? style.card_active : ""}`}
                  onClick={() => handleSelect(item.key)}
                  aria-pressed={activeChip === item.key}
                  style={{ animationDelay: `${index * 60}ms` }}
                >
                  <div className={style.card_icon}>{item.icon}</div>
                  <div className={style.card_body}>
                    <span className={style.card_name}>{item.value}</span>
                    <span className={style.card_desc}>{item.desc}</span>
                  </div>
                  <div className={style.card_check}>
                    <i className="fa fa-check" aria-hidden="true" />
                  </div>
                </button>
              ))}
            </div>

            <div className={style.notes_wrap}>
              <label className={style.notes_label} htmlFor="unable-assess-notes">
                Notes <span className={style.notes_optional}>{activeChip === "other" ? <><span className={style.required}>*</span> (Please enter your reasoning for the other)</> : "(Optional)"}</span>
              </label>
              <textarea
                id="unable-assess-notes"
                className={style.notes_textarea}
                value={notes}
                onChange={handleNoteChange}
                placeholder="Add notes here..."
                rows={3}
              />
            </div>
          </div>
        )}

        <div className={style.footer}>
          <div className={style.footer_actions}>
            {isSuccess ? (
              <button className={style.btn_secondary} onClick={onClose} aria-label="Close">
                <span>Close</span>
              </button>
            ) : (
              <button
                className={`${style.btn_primary} ${isDisabled ? style.btn_disabled : ""}`}
                onClick={handleConfirm}
                disabled={isDisabled || isLoading}
              >
                {isLoading && <div className={style.spinner}></div>}
                <span>Save</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default UnableToAssessWound;
